module.exports = __webpack_public_path__ + "img/filter-discounts-icon.05d5248e.png";